import React from 'react';
import { motion } from 'framer-motion';
const problems = ['Llegás a la clase sin saber exactamente qué serie o ejercicio vas a dar hoy', 'Tus alumnos no progresan porque no tenés una secuencia clara de nivel a nivel', 'El 40% de tus alumnos abandona antes de los 3 meses y no sabés cómo prevenirlo', 'Siempre las mismas series de siempre porque no tenés más material listo', 'No podés justificar un aumento de precio porque no tenés un sistema profesional visible', 'Correcciones técnicas improvisadas en el agua, sin un método claro que te respalde', 'Alumnos de distintos niveles juntos y la clase se convierte en un caos', 'Fin de mes y los alumnos se van sin avisar porque no ven progresión en sus clases'];
export function ProblemsSection() {
  return <section className="bg-deep py-8 sm:py-16 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-318">
      {/* Top Wave */}
      <div className="absolute top-0 left-0 right-0 w-full overflow-hidden leading-none rotate-180 z-0" data-id="element-319">
        <svg className="relative block w-full h-[30px] sm:h-[40px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-320">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V95.8C59.71,118.08,130.83,121.32,201.5,114.2,242.15,110.11,282.49,94.13,321.39,56.44Z" fill="#ffffff" data-id="element-321"></path>
        </svg>
      </div>

      <div className="max-w-4xl mx-auto relative z-10 pt-8" data-id="element-322">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl sm:text-3xl font-bold text-white text-center mb-6 sm:mb-10" data-id="element-323">
          Si sos profe de natación en Argentina, esto te va a sonar familiar:
        </motion.h2>

        <div className="space-y-2 sm:space-y-4" data-id="element-324">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 bg-white/5 rounded-xl p-3 sm:p-5 border border-white/10 hover:bg-white/10 transition-colors" data-id="element-325">
              <span className="text-agua font-black text-2xl sm:text-3xl leading-none shrink-0" data-id="element-326">
                {String(index + 1).padStart(2, '0')}
              </span>
              <p className="text-white/90 text-base sm:text-lg pt-1" data-id="element-327">
                — {problem}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mt-6 sm:mt-12 text-center" data-id="element-328">
          <h3 className="text-2xl sm:text-3xl md:text-4xl font-black text-white" data-id="element-329">
            ¿Cuántas clases más vas a improvisar al borde de la pileta?
          </h3>
        </motion.div>
      </div>

      {/* Bottom Wave */}
      <div className="absolute bottom-0 left-0 right-0 w-full overflow-hidden leading-none z-0" data-id="element-330">
        <svg className="relative block w-full h-[30px] sm:h-[40px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-331">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V95.8C59.71,118.08,130.83,121.32,201.5,114.2,242.15,110.11,282.49,94.13,321.39,56.44Z" fill="#ffffff" data-id="element-332"></path>
        </svg>
      </div>
    </section>;
}